import { calculatorClassMap } from './calculatorClassMap.mjs'
import { FakeRc } from '../FakeRc.mjs'

/**
 * Construct an instance of a running calculator from a JSON object.
 *
 * @param input the JSON object to construct from
 * @returns {*} an instance of the resulting running calculator class
 */
export function runningCalculatorFromJson(input) {
  const CalcClass = calculatorClassMap[input.calcId]
  if (!CalcClass) {
    console.warn(
      `Unknown running calculator type: ${input.calcId}, ignoring it and inserting a fake running calculator in its place.`,
    )
    return new FakeRc(input.calcId)
  }
  return new CalcClass(input)
}
